import $ from 'jquery' // jQuery

import { Autoplay, Controller, EffectFade, Parallax, Navigation, Pagination, Swiper, FreeMode } from 'swiper'
// import { SwiperSlide } from 'swiper/react'
Swiper.use([Autoplay, Controller, EffectFade, Parallax, Navigation, Pagination, FreeMode]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-top')) {
  pageTop()
}

function pageTop() {
  //  #####   ##   ####  ##  ##
  //  ##  ##  ##  ##     ## ##
  //  #####   ##  ##     ####
  //  ##      ##  ##     ## ##
  //  ##      ##   ####  ##  ##

  let topPickSwiper
  if (document.getElementById('topPick')) {
    // 片方のデバイスでのみスライダーにする
    if (window.matchMedia('(min-width:769px)').matches) {
      topPickSwiperInit()
    }
    window.addEventListener('resize', function (e) {
      if (topPickSwiper && window.matchMedia('(min-width:769px)').matches) {
        topPickSwiperInit()
      } else if (window.matchMedia('(max-width:768px)').matches) {
        if (topPickSwiper) {
          topPickSwiper.destroy()
        }
        topPickSwiper = false
      }
    })
  }
  function topPickSwiperInit() {
    const slideItem = document.getElementById('topPick')
    const sliderName = 'topPick'
    topPickSwiper = new Swiper(slideItem, {
      effect: 'slide', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      preloadImages: false, // スライド内の画像を読み終えてから開始
      slidesPerView: 'auto', //表示数変更
      spaceBetween: 50, //スライド同士の間隔を空ける
      touchRatio: 0.8, // タッチスワイプ感度（0でタッチスワイプ無効）
      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },
    })
  }

  //  #####  ##  ##    ##
  //  ##     ##   ##  ##
  //  #####  ##    ####
  //  ##     ##   ##  ##
  //  ##     ##  ##    ##

  if (document.getElementById('topFixSlide')) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars

    const slideItem = document.getElementById('topFixSlide')

    // 各要素を取得
    const slideWrap = slideItem.querySelector('.swiper-wrapper')
    const slideList = slideItem.querySelectorAll('.swiper-slide')
    let slideCount = slideList.length // スライドの数

    const slidePerViewMax = 0 * 3 // ループ表示に必要なスライド数　slidesPerViewの2倍
    // ループに不足するスライドを補充する
    while (slideCount < slidePerViewMax) {
      for (const iterator of slideList) {
        const clone = iterator.cloneNode(true)
        slideWrap.appendChild(clone)
        ++slideCount
      }
    }

    const sliderName = 'topFixSlide'
    const topFixSlideSwiper = new Swiper(slideItem, {
      // init: false, // 自動で初期化しない（topFixSlideSwiper.init()で初期化）
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 500, // アニメ速度
      loop: true, // ループ
      touchRatio: 0.3, // タッチスワイプ感度（0でタッチスワイプ無効）
      fadeEffect: {
        // フェードオプション
        crossFade: true, // クロスフェード
      },

      autoplay: {
        // オートオプション
        delay: 5000, // 待機時間
        disableOnInteraction: false, // 操作されたら停止する
      },
      pagination: {
        // ページャーオプション
        el: '.swiper-pagination--' + sliderName, // ページャーを呼び出す要素
        type: 'bullets', // bullets,fraction(現ページ/ページ数),progressbar,custom
        clickable: true, // クリックでジャンプ可能にする
      },
    })
  }

  let recruitContentHeight
  let footerTop

  $('.js-recruitInfo').on('click', function () {
    if (!$(this).hasClass('active')) {
      $('.active').removeClass('active')
      $(this).addClass('active')
      $('.js-recruitInfo-content').removeClass('show')
      $('#' + $(this).data('tab')).addClass('show')
      recruitContentHeight = $('#' + $(this).data('tab')).outerHeight()
      // $('.js-recruitInfo-content').fadeOut()
      // $('#' + $(this).data('tab')).fadeIn()
    }
  })

  $('.js-recruitMore').on('click', function () {
    $(this).toggleClass('open')

    // if ($(this).hasClass('open')) {
    //   $(this).parent().css('height', recruitContentHeight)
    // } else {
    //   $(this).parent().css('height', '75rem')
    // }

    $(this).parent().toggleClass('open')
    footerTop = $('.js-footer').offset().top - $(window).height()
  })

  $('.js-newsMore').on('click', function () {
    $(this).toggleClass('open')
    $(this).prev().slideToggle()
    footerTop = $('.js-footer').offset().top - $(window).height()
  })

  $(window).on('load', function () {
    $('#' + $('.js-recruitInfo.active').data('tab')).addClass('show')
    recruitContentHeight = $('#' + $('.js-recruitInfo.active').data('tab')).outerHeight()
    // $('#' + $('.js-recruitInfo.active').data('tab')).show()
  })

  $(window).on('load resize', function () {
    if (window.matchMedia('(min-width:769px)').matches) {
      if ($('.js-fv')[0]) {
        let fvTop = $('.js-fv').offset().top
        let fvBottom = $('.js-fvCopy-dummy').offset().top - $(window).height() * 0.4 + $('#header').outerHeight()
        let distance = 0

        distance = $(this).scrollTop()
        if (distance <= fvTop) {
          $('.js-fvCopy').removeClass('fixed')
          $('.js-fvCopy').removeClass('fixedBottom')
          $('.js-fvNews').addClass('show')
        } else if (distance >= fvBottom) {
          $('.js-fvCopy').removeClass('fixed')
          $('.js-fvCopy').addClass('fixedBottom')
          $('.js-fvNews').removeClass('show')
        } else {
          $('.js-fvCopy').addClass('fixed')
          $('.js-fvCopy').removeClass('fixedBottom')
          $('.js-fvNews').addClass('show')
        }

        $(document).on('scroll', function () {
          distance = $(this).scrollTop()
          if (distance <= fvTop) {
            $('.js-fvCopy').removeClass('fixed')
            $('.js-fvCopy').removeClass('fixedBottom')
            $('.js-fvNews').addClass('show')
          } else if (distance >= fvBottom) {
            $('.js-fvCopy').removeClass('fixed')
            $('.js-fvCopy').addClass('fixedBottom')
            $('.js-fvNews').removeClass('show')
          } else {
            $('.js-fvCopy').addClass('fixed')
            $('.js-fvCopy').removeClass('fixedBottom')
            $('.js-fvNews').addClass('show')
          }
        })
      }

      if ($('.js-formFlow')[0]) {
        let formTop = $('.js-formPage').offset().top
        let formBottom = $('.js-formContent').offset().top + $('.js-formContent').height() - $('.js-formFlow').height()
        let distance = 0
        $(document).on('scroll', function () {
          distance = $(this).scrollTop()
          if (distance <= formTop) {
            $('.js-formFlow').removeClass('fixed')
            $('.js-formFlow').removeClass('fixedBottom')
          } else if (distance >= formBottom) {
            $('.js-formFlow').removeClass('fixed')
            $('.js-formFlow').addClass('fixedBottom')
          } else {
            $('.js-formFlow').addClass('fixed')
            $('.js-formFlow').removeClass('fixedBottom')
          }
        })
      }

      if ($('.js-floorNav')[0]) {
        let floorBottom = $('.js-floor').offset().top + $('.js-floor').height() - $(window).height()
        let floorNavBottom = $('.js-floorNav').offset().top + $('.js-floorNav').height()
        let distance = 0
        $(document).on('scroll', function () {
          distance = $(this).scrollTop()
          if (distance <= floorNavBottom) {
            $('.js-floorNav').removeClass('small')
            $('.js-floorNav').removeClass('fixed')
            $('.js-floorNav').removeClass('fixedBottom')
          } else if (distance >= floorBottom) {
            $('.js-floorNav').addClass('small')
            $('.js-floorNav').removeClass('fixed')
            $('.js-floorNav').addClass('fixedBottom')
          } else {
            $('.js-floorNav').addClass('small')
            $('.js-floorNav').addClass('fixed')
            $('.js-floorNav').removeClass('fixedBottom')
          }
        })
      }

      if ($('.js-floorHead-01')[0]) {
        const floorHead = $('.js-floorHead-01')
        floorSecHead(floorHead)
      }
      if ($('.js-floorHead-02')[0]) {
        const floorHead = $('.js-floorHead-02')
        floorSecHead(floorHead)
      }
      if ($('.js-floorHead-03')[0]) {
        const floorHead = $('.js-floorHead-03')
        floorSecHead(floorHead)
      }
      if ($('.js-floorHead-04')[0]) {
        const floorHead = $('.js-floorHead-04')
        floorSecHead(floorHead)
      }
    }
  })
  function floorSecHead(floorHead) {
    const floorSec = floorHead.parents('.js-floorSec')
    let floorSecTop = floorSec.offset().top
    let floorSecBottom = floorSec.offset().top + floorSec.height() - floorHead.height()
    let distance = 0
    $(document).on('scroll', function () {
      distance = $(this).scrollTop()
      if (distance <= floorSecTop) {
        floorHead.removeClass('fixed')
        floorHead.removeClass('fixedBottom')
      } else if (distance >= floorSecBottom) {
        floorHead.removeClass('fixed')
        floorHead.addClass('fixedBottom')
      } else {
        floorHead.addClass('fixed')
        floorHead.removeClass('fixedBottom')
      }
    })
  }

  /*
 #######  ########  ######## ##    ## #### ##    ##  ######
##     ## ##     ## ##       ####  ##  ##  ####  ## ##
##     ## ########  ######   ## ## ##  ##  ## ## ## ##   ####
##     ## ##        ##       ##  ####  ##  ##  #### ##    ##
 #######  ##        ######## ##    ## #### ##    ##  ######
*/
  if (window.matchMedia('(min-width:769px)').matches) {
    if ($('.js-opening')[0]) {
      // クッキー処理
      const cookieArray = []
      if (document.cookie !== '') {
        const tmp = document.cookie.split('; ')
        for (let i = 0; i < tmp.length; i++) {
          const data = tmp[i].split('=')
          cookieArray[data[0]] = decodeURIComponent(data[1])
        }
      }
      const acceptCookie = cookieArray['acceptCookie']
      if (!acceptCookie) {
        // if (1) {
        document.cookie = 'acceptCookie=allready;max-age=' + 60 * 60 * 24 + ';path=/'

        // ローディングアニメーション
        $(window).on('load', function () {
          setTimeout(function () {
            $('.js-opening-img').addClass('show')
          }, 1400)
          setTimeout(function () {
            $('.js-opening-logo').addClass('show')
          }, 2900)
          setTimeout(function () {
            $('.js-opening').fadeOut(1000)
          }, 4900)
        })
      } else {
        $('.js-opening').hide()
      }
    }
  }
}
